import React, { FC } from 'react';
import ContractForm from './components/ContractForm';

const Contract: FC = () => {
  return <ContractForm />;
};

export default Contract;
